import { render, staticRenderFns } from "./cert.vue?vue&type=template&id=07241a70&"
import script from "./cert.vue?vue&type=script&lang=js&"
export * from "./cert.vue?vue&type=script&lang=js&"
import style0 from "./cert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports